<template>
	<div class="card-compare">
		<template v-for="attrib in attribs">
			<div v-if="attrib.title" :key="attrib.id">
				<div class="d-flex flex-column justify-content-center align-items-center">
					<h5 class="my-3 text-center">{{ attrib.title }}</h5>
				</div>
			</div>
			<div v-else-if="attrib.bool" :key="attrib.id">
				<div
					class="d-flex justify-content-between align-items-center p-0 m-0 mb-3"
				>
					<b-avatar
						variant="dark"
						class="p-0 m-0 bv-avatar align-self-start"
						square
						style="min-width: 25px"
					>
						<slot>
							<div v-if="attrib.img">
								<b-img :src="imgPath + attrib.img" fluid />
							</div>
							<div v-else>
								<font-awesome-icon
									:icon="attrib.icon ? attrib.icon : 'question'"
								/>
							</div>
						</slot>
					</b-avatar>
					<span class="flex-grow-1 text-responsive text-left mx-2 bool-text">
						{{ attrib.label }}
					</span>
					<span class="bool-icon mr-2 text-responsive">
						<font-awesome-icon
							:icon="attrib.value ? 'check-circle' : 'times-circle'"
							:class="attrib.value ? 'text-success' : 'text-danger'"
						/>
					</span>
				</div>
			</div>
			<div v-else-if="attrib.justImg" :key="attrib.id">
        <div class="card-compare__title">
          <span v-if="attrib.label" class="label-text text-responsive">{{ attrib.label }}</span>
          <b-img :src="imgPath + attrib.img" fluid />
        </div>
			</div>
			<div v-else :key="attrib.id">
					<div class="flex-grow-1 text-left">
						<b-avatar
							variant="white"
							class="p-0 m-0 align-self-start"
							square
							style="min-width: 24px"
						>
							<slot>
								<div v-if="attrib.img">
									<b-img :src="imgPath + attrib.img" fluid />
								</div>
								<div v-else>
									<font-awesome-icon
										:icon="attrib.icon ? attrib.icon : 'question'"
									/>
								</div>
							</slot>
						</b-avatar>
						<span class="label-text text-responsive">{{ attrib.label }}</span>
						<span class="d-block d-xs-none d-sm-none text-responsive">{{
							attrib.valueLabel
						}}</span>
						<div class="card-compare__field d-flex">
							<font-awesome-icon
								:icon="attrib.lessIsMore ? 'smile' : 'frown'"
								:class="
									'text-' +
									frontIcon(attrib.value, attrib.maxValue, attrib.lessIsMore)
								"
                class="mr-1"
							/>
							<b-progress
                class="card-compare__field__value__progress flex-grow-1"
								:max="1"
								show-value
								height="1.5rem"
							>
								<b-progress-bar
									:value="attrib.value / attrib.maxValue"
									:variant="
										progressVariant(
											attrib.value,
											attrib.maxValue,
											attrib.lessIsMore
										)
									"
								>
									<slot
										><span class="d-none d-lg-block">{{
											attrib.valueLabel
										}}</span></slot
									>
								</b-progress-bar>
							</b-progress>
							<font-awesome-icon
								:icon="attrib.lessIsMore ? 'frown' : 'smile'"
								:class="
									'text-' +
									backIcon(attrib.value, attrib.maxValue, attrib.lessIsMore)
								"
                class="ml-1"
							/>
						</div>
					</div>
			</div>
      <div class="card-compare__divider" :key="`${attrib.id}-divider`" />
		</template>
    <div class="d-flex justify-content-center align-items-center">
      <b-button
        @click="()=>{$emit('vote')}"
        variant="primary"
        class="d-flex px-4"
      >
        <font-awesome-icon icon="thumbs-up" />
      </b-button>
    </div>
	</div>
</template>
<script>
export default {
	props: ["attribs", "imgPath"],
	methods: {
		isStartMiddleEnd: function (value, max) {
			if (value < max * 0.33) {
				return 1;
			} else if (value > max * 0.66) {
				return 3;
			} else {
				return 2;
			}
		},
		progressVariant: function (value, max, lessIsMore) {
			let whichThird = this.isStartMiddleEnd(value, max);

			if (whichThird == 1) {
				return lessIsMore ? "success" : "danger";
			} else if (whichThird == 3) {
				return lessIsMore ? "danger" : "success";
			} else {
				return "warning";
			}
		},
		frontIcon: function (value, max, lessIsMore) {
			let whichThird = this.isStartMiddleEnd(value, max);

			if (whichThird == 1) {
				return lessIsMore ? "success" : "danger";
			} else if (whichThird == 2) {
				return "warning";
			} else {
				return "muted";
			}
		},
		backIcon: function (value, max, lessIsMore) {
			let whichThird = this.isStartMiddleEnd(value, max);

			if (whichThird == 3) {
				return lessIsMore ? "danger" : "success";
			} else if (whichThird == 2) {
				return "warning";
			} else {
				return "muted";
			}
		},
	},
};
</script>
<style>
.bool-text,
.label-text {
	font-weight: bold;
}
.bool-icon {
	font-size: 1.5rem;
}

.bool-success,
.bool-danger,
.bool-warning {
	border-width: 4px !important;
}

.bool-success {
	border-color: #2eca8b !important ;
}
.bool-danger {
	border-color: #e43f52 !important;
}
.bool-warning {
	border-color: #f17425 !important;
}
.attrib-bg {
	background: #f3f3f3;
}

.bv-avatar {
	width: 5rem;
	height: 5rem;
}

@media (min-width: 300px) and (max-width: 768px) {
	.bv-avatar {
		width: 3rem !important;
		height: 3rem !important;
	}

	.text-responsive {
		font-size: calc(1vw + 1vh);
	}
}
</style>
